import { render, staticRenderFns } from "./VesselLiveDataCard.vue?vue&type=template&id=6e09611e&scoped=true&"
import script from "./VesselLiveDataCard.vue?vue&type=script&lang=js&"
export * from "./VesselLiveDataCard.vue?vue&type=script&lang=js&"
import style0 from "./VesselLiveDataCard.vue?vue&type=style&index=0&id=6e09611e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e09611e",
  null
  
)

export default component.exports